import { useFormContext } from '@form-engine/core-application/hooks/use-form';
import { useFormSessionContext } from '@form-engine/core-application/hooks/use-formsession';
import { StoreReference } from '@form-engine/core-application/hooks/use-store';
import { FormSession } from '@form-engine/core-application/types/form';
import { useEffect } from 'react';

export const sessionRemotes = new Map<string, StoreReference<FormSession>>();

export default function BsoFormEngineSessionRemote() {
    const session = useFormSessionContext();
    const { state: form } = useFormContext();
    useEffect(() => {
        if (!form.id) {
            return;
        }
        sessionRemotes.set(form.id, session);
        return () => {
            sessionRemotes.delete(form.id!);
        };
    }, [form.id, session]);

    return null;
}
